module.exports = __webpack_public_path__ + "static/media/digital-dollars-value.081df0da.png";